(function () {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const updateAnnouncements = (root = document) => {
    root.querySelectorAll('.announcement-bar').forEach((bar) => {
      const slider = bar.querySelector('.announcement-bar__slide');
      if (!slider) return;

      const slides = slider.querySelectorAll('.swiper-slide');
      const configuredSpeed = Number(slider.dataset.announcementSpeed);
      const duration = Number.isFinite(configuredSpeed) && configuredSpeed > 0 ? configuredSpeed : 5;
      bar.style.setProperty('--announcement-duration', `${duration}s`);
      bar.style.setProperty('--announcement-step', slides.length > 0 ? `${-100 / slides.length}%` : '0%');
      bar.classList.toggle('announcement--reduced-motion', reducedMotion.matches);
      bar.classList.toggle('announcement--paused', document.hidden);
      bar.classList.toggle(
        'announcement__slide-show',
        window.innerWidth < 576 && !reducedMotion.matches && slides.length > 0
      );

      // Only one copy is exposed to assistive technology and keyboard navigation.
      slides.forEach((slide, index) => {
        slide.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');
        slide.inert = index !== 0;
      });
    });
  };

  updateAnnouncements();
  window.addEventListener('resize', () => updateAnnouncements());
  reducedMotion.addEventListener('change', () => updateAnnouncements());
  document.addEventListener('shopify:section:load', (event) => updateAnnouncements(event.target));
  document.addEventListener('visibilitychange', () => {
    document.querySelectorAll('.announcement-bar').forEach((bar) => {
      bar.classList.toggle('announcement--paused', document.hidden);
    });
  });
})();
